"use client";
import * as React from "react";
const SvgSpeedFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m14.7 4.2-.98 1.5a6.6 6.6 0 0 1-.18 6.17H2.44a6.6 6.6 0 0 1-.82-4 6.6 6.6 0 0 1 1.7-3.72A6.4 6.4 0 0 1 6.87 2.2a6.3 6.3 0 0 1 3.99.59l1.48-1a7.9 7.9 0 0 0-9.85.95A8.2 8.2 0 0 0 .1 7.46a8.3 8.3 0 0 0 .97 5.22q.22.38.58.6s.52.22.8.22h11.1a1.6 1.6 0 0 0 1.39-.82A8 8 0 0 0 16 8.4a8 8 0 0 0-1.29-4.22v.01ZM6.86 9.75a1.6 1.6 0 0 0 1.13.48 1.6 1.6 0 0 0 1.13-.48l4.54-6.91-6.8 4.6a1.6 1.6 0 0 0-.47 1.16 1.7 1.7 0 0 0 .47 1.15" }));
export {
  SvgSpeedFilled as default
};
